import { createSelector } from 'reselect';
import findWhere from 'selectors/findWhere.js';

const bucketIds = state => state.buckets.ids;
const buckets = state => state.buckets.models;
const indicatorId = (_, indicatorId) => indicatorId;

export default createSelector(
    [bucketIds, buckets, indicatorId],
    (ids, models, indicatorId) => findWhere(ids.map(id => models[id]), { indicator_id: indicatorId })
);
